import React from 'react';
import './HomeTopNav.css';

export type HomeLanguage = 'en' | 'zh';

export type HomeTopNavLabels = {
  about: string;
  showcase: string;
  writing: string;
  contact: string;
};

type HomeTopNavProps = {
  isVisible: boolean;
  labels?: HomeTopNavLabels;
  onAboutClick: () => void;
  onShowcaseClick: () => void;
  onWritingClick: () => void;
  onContactClick: () => void;
};

const DEFAULT_LABELS: HomeTopNavLabels = {
  about: 'about me',
  showcase: 'showcase',
  writing: 'writing',
  contact: 'contact',
};

export const HomeTopNav: React.FC<HomeTopNavProps> = ({
  isVisible,
  labels = DEFAULT_LABELS,
  onAboutClick,
  onShowcaseClick,
  onWritingClick,
  onContactClick,
}) => (
    <nav
      aria-label="Primary"
      className={`home-top-nav${isVisible ? '' : ' is-hidden'}`}
    >
      <button type="button" className="home-top-nav-link" onClick={onAboutClick}>
        {labels.about}
      </button>
      <button type="button" className="home-top-nav-link" onClick={onShowcaseClick}>
        {labels.showcase}
      </button>
      <button type="button" className="home-top-nav-link" onClick={onWritingClick}>
        {labels.writing}
      </button>
      <button type="button" className="home-top-nav-link" onClick={onContactClick}>
        {labels.contact}
      </button>
    </nav>
);
